const TeamSquadTypes = {
    GET_TEAM_SQUAD_START:'GET_TEAM_SQUAD_START',
    GET_TEAM_SQUAD_SUCCESS:'GET_TEAM_SQUAD_SUCCESS',
    GET_TEAM_SQUAD_FAILED:'GET_TEAM_SQUAD_FAILED',

}

export default TeamSquadTypes